// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"23b4b900","703":"e26e0ba2","787":"a3e0faf2"}[chunkId] + ".chunk.js";
};